import { useRouter } from 'next/router'
import * as React from 'react'
import { useState } from 'react'
import { useContext } from 'react'
import { onGetUser, onGetRegUser } from '../src/utils/queries'
import { useQueryClient } from 'react-query'

const AuthContext = React.createContext()


const initState = {
   
}
export function AuthContextProvider({children}){
    const publicRoutes = ["/login", "/register", "/reset", '/reset/verification', '/register/organization', '/register/verification','/register/organizatiion/onboarding', '/reset/verification', '/pricing'];
    const router = useRouter();
    //   const { isAuthenticated, isLoading } = useAuth();
    
    const pathIsNotPublic = publicRoutes.indexOf(router.pathname) == -1;

    // console.log(pathIsNotPublic)
    const queryClient = useQueryClient()
    const { data:userData, isSuccess:userIsSuccess, isError:userIsError, isLoading } = onGetUser(pathIsNotPublic)

    const [state, setState]= useState(initState)
    React.useEffect(()=>{
        if(userIsSuccess){
            const userInfo = userData?.data?.data?.user
            const title = userData?.data?.data?.user
           setState({
               ...state,
               verified:userInfo.email_verified_at,
               user:userInfo.donee,
               email:userInfo.email,
               title:userInfo.title,
               first_name:userInfo.first_name,
               last_name:userInfo.last_name
           })
           
        }
    },[userIsSuccess, userIsError, userData])

    const clearState = () =>{
        queryClient.clear()
        setState({

        })
    }
  
    const setAuthContext = (context)=>{
        
        setState({...state, ...context})
    }
    return <AuthContext.Provider value={{...state, setAuthContext, clearState, isLoading}}>
        {children}
    </AuthContext.Provider>
}


export function useAuthProvider(){
    const context = React.useContext(AuthContext)
    if (context === undefined){
        throw new Error('useAuth must be within a provider')
    }
    return context
}